(function (angular) {
	'use strict';

	var questionnaireFirstStepObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {},
		controller: [
			'APP_BASE_PATH',
			'urlFactory',
			QuestionnaireFirstStepFunction
		],
		controllerAs: 'questionnaireFirstStep'
	};

	angular
		.module('questionnaireModule')
		.component('questionnaireFirstStep', questionnaireFirstStepObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/ria/questionnaire/questionnaire-first-step.html';
	}

	function QuestionnaireFirstStepFunction(
		APP_BASE_PATH,
		urlFactory
	) {	
		var questionnaireFirstStep = this;

		questionnaireFirstStep.continue = function() {
			var urlParams = {
				skipFirstStep: true,
				age: questionnaireFirstStep.age,
				retired: questionnaireFirstStep.retired
			};
			
			var realEstateExperience = [];
			
			angular.forEach(questionnaireFirstStep.realEstateExperience, function(value, key){
				if (value) {
					realEstateExperience.push(key);
				}
			});
			
			urlParams.realEstateExperience = realEstateExperience;
			
			var redirectUrl = urlFactory.serializeParamsAndCreateUrl('select-goal-help', urlParams);
			
			urlFactory.redirect(redirectUrl);
		};

		questionnaireFirstStep.$onInit = function() {
			questionnaireFirstStep.basePath = APP_BASE_PATH;
			questionnaireFirstStep.retirementOptions = ['retired', 'not retired'];
			questionnaireFirstStep.retired = questionnaireFirstStep.retirementOptions[1];

			questionnaireFirstStep.realEstateExperience = {
				homeOwnership: false,
				rentalProperties: false,
				flippingHouses: false,
				reits: false
			};
		};
	}
})(window.angular);